<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Travellers History</h3>
        <div class="text-xs-right">
          <export-excel-button :export-data="exportData"
                               v-if="$oauth.checkIfHasPermission(['export traveller-scan-report'])"/>
          <refresh-button :click-function="refreshData"></refresh-button>
        </div>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs3 class="pb-0">
              <v-text-field
                  flat
                  hide-details
                  placeholder="Search by typing here..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="fetchFiltersData"
              />
            </v-flex>
            <v-flex xs3 class="pb-0">
              <v-text-field
                  flat
                  hide-details
                  placeholder="Document Number"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.document_number"
                  @keypress.enter="fetchFiltersData"
              />
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Filter By Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.country"
                  @change="fetchFiltersData"
              />
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="purposes"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="purpose"
                  item-value="id"
                  label="Filter By Purpose"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.purpose"
                  @change="fetchFiltersData"
              />
            </v-flex>
          </v-layout>
          <v-divider/>
          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="data"
                :loading="loading"
                :server-items-length="totalNumber"
                :options.sync="pagination"
                class="elevation-0"
              >
              <template v-slot:item.country_name="{ item }">
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                                            <span
                                                v-on="on">{{ item.country_code }}</span>
                    </template>
                    <span>{{ item.country_name }}</span>
                  </v-tooltip>
                </td>
              </template>

              <template v-slot:item.action="{ item }">
                <td>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          @click="view(item)"
                          color="primary"
                          dark
                          dense
                          fab
                          v-on="on"
                          x-small
                          :href="'/system/travellers-history/view/'+item.id"
                          :to="'/system/travellers-history/view/'+item.id"
                      >
                        <v-icon small>remove_red_eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
<!--            <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"-->
<!--                                :disable-next="disableNext"-->
<!--                                :disable-prev="disablePrev"-->
<!--                                :perPage="pagination.itemsPerPage"-->
<!--                                @rowChanged="fetchDataWithRow"-->
<!--                                @getCount="getCount"-->
<!--                                :total="total"-->
<!--                                :items-loading="totalItemsLoading"-->
<!--                                :showing-of="showingOf"-->
<!--            />-->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {mapActions, mapMutations, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportExcelButton from "../../components/ExportExcelButton";
import FlatDatePicker from "../../components/FlatDatePicker";
import RefreshButton from "@/components/RefreshButton";
import Http from "axios";
import {API_URL, VERSION} from "../../config/config";

export default {
  data() {
    return {
      title: "Traveller Scan Report",
      totalNumber: 0,
      // pagination: {
      //     itemsPerPage: 25,
      //     sortBy: ["travellers.created_at"],
      //     sortDesc: ["true"]
      // },
      headers: [
        {
          text: 'S.N.',
          value: 's_no',
        },
        {
          text: "Full Name",
          value: "full_name",
        },
        {
          text: "Country",
          value: "country_name",
        },
        {
          text: "Gender",
          value: "gender",

        },
        {
          text: "Document Number",
          value: "document_number"
        },
        {
          text: "Service Provider",
          value: "service_provider"
        },
        {
          text: "Purpose",
          value: "purpose"
        },
        {
          text: "Scanned On",
          value: "created_at"
        },
      ]
    };
  },
  components: {RefreshButton, FlatDatePicker, CustomDateRangePicker, IssuedVisaFooter, ExportExcelButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "TravellersScanReport/reportLoading",
      countries: "CountryList/all",
      purposes:"ServiceProvider/serviceProviderPurposes"
    })
  },

  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries"
    }),


    view(item) {
      this.$router.push({
        name: "TravellerDetail",
        params: {id: item.id.toString()}
      });
    },
    refreshData() {
      this.fetchData();
      this.fetchTotalNumber();
    },
  async fetchTotalNumber() {
    try {
      const response = await Http.get(API_URL + VERSION+ '/travellers-histories/scan-report-count');
      if (response) {
        this.totalNumber = response.data.count_tracks;
      } else {
        this.totalNumber = 0;
      }
    } catch (error) {
      console.error("Error fetching total traveller scans:", error);
      this.totalNumber = 0;
    }
  }
},
  created() {
    if (this.$oauth.checkIfHasPermission(['read traveller-scan-report']))
      this.headers.push(
          {
            text: "Action",
            value: "action",
            sortable: false
          })
  },
  mounted() {
    this.stateName = 'TravellersScanReport';
    this.commonState = this.$store.state.TravellersScanReport;
    this.fetchCountries();
    this.$store.dispatch('ServiceProvider/getAllServiceProviderPurpose');
    this.fetchTotalNumber();
  }
};
</script>
